var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationsCountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.62rem",
    viewBox: "0 0 45 35.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder-open-solid",
    d: "M6.93,46.985,0,58.861V37a5,5,0,0,1,5-5h9.18a5,5,0,0,1,3.539,1.461l2.07,2.07a5,5,0,0,0,3.539,1.461H32.5a5,5,0,0,1,5,5v2.5H11.251A5,5,0,0,0,6.93,46.978Zm2.156,1.258A2.5,2.5,0,0,1,11.251,47H42.5a2.505,2.505,0,0,1,2.156,3.766l-8.751,15A2.489,2.489,0,0,1,33.752,67H2.5A2.505,2.505,0,0,1,.344,63.236l8.751-15Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsCountIcon);
export default __webpack_public_path__ + "static/media/applications-count-icon.a17f1be62e42b37125dbda734ee73c92.svg";
export { ForwardRef as ReactComponent };